import { useSignal } from '@preact/signals-react';
import { useSelector } from 'react-redux';
import {
  DashboardHeader,
  DashboardMain,
  DashboardWelcome,
  NotificationSidePanel,
  Loader,
} from 'components';
import { isAdvertiserRole } from 'store/selectors';
import { globalAPI } from 'services/global.service';
import { getDayMonthYear } from 'utils';
import * as S from './Dashboard.styled';

const getThisMonthRange = () => {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth(), 1);
  const to = now;

  return {
    from: getDayMonthYear(from),
    to: getDayMonthYear(to),
  };
};

const Dashboard = () => {
  const thisMonthRange = getThisMonthRange();
  const dateFrom$ = useSignal(thisMonthRange.from);
  const dateTo$ = useSignal(thisMonthRange.to);
  const dateRangeName$ = useSignal('This Month');

  const isAdvertiser = useSelector(isAdvertiserRole);
  const { data: newUserData, isLoading: isNewUserLoading } = globalAPI.useDetectNewUserQuery();
  const isNewUser = Boolean(newUserData?.isNewUser);

  if (isNewUserLoading) return <Loader.Global delay={0} />;

  const MainPanel = isNewUser
    ? DashboardWelcome
    : isAdvertiser
    ? DashboardMain.Advertiser
    : DashboardMain.Publisher;

  return (
    <S.Wrap>
      <DashboardHeader dateRangeName$={dateRangeName$} dateFrom$={dateFrom$} dateTo$={dateTo$} />
      <S.Content isAdvertiser={isAdvertiser}>
        <MainPanel dateFrom$={dateFrom$} dateTo$={dateTo$} isAdvertiser={isAdvertiser} />
        {isAdvertiser && <NotificationSidePanel dateFrom$={dateFrom$} dateTo$={dateTo$} />}
      </S.Content>
    </S.Wrap>
  );
};

export default Dashboard;
